import React from 'react';
import { UnitConverter } from './UnitConverter';

const units = [
  { key: 'sqinch', label: 'Sq Inch' },
  { key: 'sqmet',  label: 'Sq Meter' },
  { key: 'sqcent', label: 'Sq Centimeter' },
  { key: 'sqyard', label: 'Sq Yards' },
  { key: 'sqfeet', label: 'Sq Feet' },
  { key: 'hect',   label: 'Hectares' },
  { key: 'acre',   label: 'Acres' },
  { key: 'sqmile', label: 'Sq Miles' },
];

// Base: sq inch
const factors = {
  sqinch: 1,
  sqmet:  1 / 1550.003,
  sqcent: 6.452,
  sqyard: 1 / 1296,
  sqfeet: 1 / 144,
  hect:   1 / 15500000,
  acre:   1 / 6273000,
  sqmile: 1 / 4014000000,
};

export const ConvArea = () => (
  <UnitConverter
    title="Area"
    units={units}
    factors={factors}
    explanationTitle="Units of area"
    explanation="1 sq ft = 0.0929 sq metres. In the English system, one square foot is approximately 0.093 times a square metre in the metric system."
  />
);
